var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h2', [_vm._v("我的考试")]), _c('a-divider'), _c('a-card', {
    staticClass: "search-card",
    attrs: {
      "bordered": false
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "right-circle",
      "type": "danger"
    },
    on: {
      "click": _vm.toMyPaperAnswer
    }
  }, [_vm._v("查看我的模拟练习")]), _c('br'), _c('br'), _c('a-table', {
    ref: "table",
    staticClass: "j-table-force-nowrap",
    attrs: {
      "scroll": {
        x: true
      },
      "bordered": "",
      "size": "middle",
      "rowKey": "id",
      "columns": _vm.columns,
      "dataSource": _vm.paperDataSource,
      "pagination": _vm.pagination,
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function fn(text, record) {
        return _c('span', {}, [_c('a-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.toPaper(record);
            }
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('exam.toExam')))]), _c('a-icon', {
          attrs: {
            "type": "right"
          }
        })], 1)], 1);
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };